__webpack_require__.p = "/_CDN_URL_TEMPLATE_/super-funnel/main/b/0-10396/_next/";